import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function CardActionArrow({ size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 34 34" width={size} {...props}>
      <Circle cx={17} cy={17} r={15.5} stroke="#D1D3D4" />
      <Path
        d="M11.4889 17H22.4889"
        stroke="#58595B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <Path
        d="M18.2287 21.2826L22.5112 17L18.2287 12.7175"
        stroke="#58595B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </Svg>
  );
});
